import { AnimatePresence } from 'framer-motion';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { HeaderMenu } from '@/components/landing/blocks';
import { Button, PinkButton } from '@/components/UI';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { GenerateLandingLinkService } from '@/services';
import { getLocaleFromPath } from '@/helpers/getLocaleFromPath';
import { DEFAULT_LOCALE } from '@/constants';
import ArrowIcon from '@/public/icons/arrow-thin.svg';
import LogoIcon from '@/public/icons/logo-text.svg';
import styles from './Header.module.scss';

export const Header = () => {
	const { t } = useTranslationWithLocale('landing-header');
	const router = useRouter();
	const pathForLocale = router.asPath?.split('?')[0] || '/';
	const locale = getLocaleFromPath(pathForLocale);
	const homeHref = locale === DEFAULT_LOCALE ? '/' : `/${locale}`;
	const [isMenuOpen, setIsMenuOpen] = React.useState(false);
	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
		document.body.style.overflow = '';
	};
	const goToProduct = () => {
		window.location.href = GenerateLandingLinkService.webApp();
	};

	return (
		<header className={styles['header']} id='header'>
			<Container className={styles['header__container']}>
				<div className={styles['header__content']}>
					<Link
						href={homeHref}
						className={styles['header__logo']}
						aria-label='Go to homepage'
					>
						<LogoIcon className={`${styles['header__icon']}`} />
					</Link>

					<div className={styles['header__info']}>
						<PinkButton
							onClick={toggleMenu}
							ariaExpanded={isMenuOpen}
							text={t('create')}
							Icon={ArrowIcon}
							controlsId='create-dropdown'
						/>

						<AnimatePresence initial={false}>
							{isMenuOpen ? <HeaderMenu toggleMenu={toggleMenu} /> : null}
						</AnimatePresence>

						<Button
							as='button'
							onClick={goToProduct}
							text={t('logIn')}
							preset='landing'
						/>
					</div>
				</div>
			</Container>
		</header>
	);
};
